import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { WagmiProvider } from 'wagmi';

import { store } from '@/store';

import './plugins/assets';
import App from './App.tsx';
import FallbackRender from './components/ErrorBoundary.tsx';
import { config } from './config/wagmi.ts';
import { setupI18n } from './locales';
import { setupAppVersionNotification, setupDayjs, setupIconifyOffline, setupNProgress } from './plugins';

console.log(QueryClientProvider);

function setupApp() {
  setupI18n();

  const container = document.getElementById('root');

  if (!container) return;

  const root = createRoot(container);

  const queryClient = new QueryClient();

  root.render(
    <ErrorBoundary fallbackRender={FallbackRender}>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <App />
          </Provider>
        </QueryClientProvider>
      </WagmiProvider>
    </ErrorBoundary>
  );

  setupNProgress();

  setupIconifyOffline();

  setupDayjs();

  setupAppVersionNotification();
}

setupApp();
